export default "__VITE_ASSET__i4bGS9fK__"